import { NotificationsModule } from './notifications/notifications.module';
import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
  MaterialFormsModule,
  MaterialUserInterfaceModule
} from 'ng2-material-components/ng2-material-components';

import { SharedModule } from './shared/shared.module';
import { SideNavComponent } from './sidenav';
import { routing } from './app.routing';

// services
import { ApiService } from './shared/services';
import { AppStateService } from './shared/services';
import { AuthService } from './shared/services';
import { ManagementService } from './shared/services';
import { Store } from './shared/services';
import { StoreHelper } from './shared/services';
import { UserService } from './shared/services';
import { ConfigService } from './shared/services';
import { LocalStorageService } from './shared/services';
import { AccountsService } from './shared/services';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { DashboardModule } from './dashboard/dashboard.module';

// features
import { AccountsModule } from './accounts/accounts.module';
import { EmployeesModule } from './employees/employees.module';
import { AccountingModule } from './accounting/accounting.module';
import { LocationModule } from './location/location.module';
import { InventoryModule } from './inventory/inventory.module';
import { CustomersModule } from './customers/customers.module';
import { ChatModule } from './chat/chat.module';
import { ClockInOutModule } from './clock-in-out';
import { SettingsModule } from './settings';

import { removeNgStyles, createNewHosts } from '@angularclass/hmr';

@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    routing,
    MaterialFormsModule,
    MaterialUserInterfaceModule,
    SharedModule,
    DashboardModule,
    // features
    AccountsModule,
    EmployeesModule,
    AccountingModule,
    LocationModule,
    InventoryModule,
    CustomersModule,
    NotificationsModule,
    ChatModule,
    ClockInOutModule,
    SettingsModule
  ],

  declarations: [
    AppComponent,
    HomeComponent,
    SideNavComponent,
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    ApiService,
    AppStateService,
    AuthService,
    ConfigService,
    ManagementService,
    Store,
    StoreHelper,
    UserService,
    LocalStorageService,
    AccountsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(public appRef: ApplicationRef) {}
  hmrOnInit(store) {
    console.log('HMR store', store);
  }
  hmrOnDestroy(store) {
    let cmpLocation = this.appRef.components.map(cmp => cmp.location.nativeElement);
    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // remove styles
    removeNgStyles();
  }
  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.module.ts